import { useCallback, useState } from "react";
import styled from "styled-components";

import uploadFile from "../../../../../../clients/brandMedia/uploadFile";
import useCreateBrandMediumUploadSession from "../../../../../../clients/brandMedia/useCreateBrandMediumUploadSession";
import * as UI from "../../../../../../modules/ui-kit";

export default function Upload(props) {
    const { brandID, disabled, file, onUploaded } = props;

    const [upload, isUploading] = useUpload(brandID, file);

    const [progress, setProgress] = useState(0);

    function onProgress(uploaded: number, total: number) {
        setProgress(uploaded / total);
    }

    return (
        <Styled
            $progress={ progress }
            disabled={ disabled || isUploading }
            onClick={ () => upload(onProgress, onUploaded) }
        >
            { isUploading ? "Uploading ..." : "Upload file" }
            <div></div>
        </Styled>
    );
}

const Styled = styled(UI.Button)<{ $progress: number }>`
    position: relative;
    overflow: hidden;
    z-index: 0;

    div {
        background: #0002;
        height: 100%;
        left: 0;
        position: absolute;
        top: 0;
        transition: 500ms ease;
        width: calc(100% * ${ ({ $progress }) => $progress });
        z-index: -1;
    }
`;


function useUpload(brandID: string, file: File) {
    const [createBrandMediumUploadSession] = useCreateBrandMediumUploadSession();

    const [isUploading, setIsUploading] = useState(false);

    const upload = useCallback(
        async function upload(onUploadProgress, onSuccess) {
            setIsUploading(true);

            const mutation = await createBrandMediumUploadSession(
                {
                    variables: {
                        brandID,
                        filename: file.name,
                    },
                }
            );

            await uploadFile(
                mutation.data.createBrandMediumUploadSession.uploadURL,
                file,
                onUploadProgress,
            );

            onSuccess?.(mutation.data.createBrandMediumUploadSession.fileURL);
        },
        [],
    );

    return [
        upload,
        isUploading,
    ];
}
